import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-monokai";
export const Flex = () =>{


    return(
    
        <div id="articleContent" className="flex">
            <h2>Propriétés pour les parents</h2>
            <table>
            <thead><tr><th>Propriétés</th><th>Valeurs</th><th>Détails</th></tr></thead>
            <tr>
                    <td>display</td>
                    <td><ul>
                        <li>flex</li>
                        <li>inline-flex</li>
                    </ul></td>
                    <td>Les autres valeurs de display sauf display none ne fonctionnera plus sur les items</td>
                </tr>
                <tr>
                    <td>flex-direction</td>
                    <td><ul>
                        <li>row</li>
                        <li>row-reverse</li>
                        <li>column</li>
                        <li>column-reverse</li>
                    </ul></td>
                    <td>Determine l'axe principale</td>
                </tr>
                <tr>
                    <td>flex-wrap</td>
                    <td><ul>
                        <li>nowrap</li>
                        <li>wrap</li>
                        <li>wrap-reverse</li>
                    </ul></td>
                    <td></td>
                </tr>
                <tr>
                    <td>flex-flow</td>
                    <td>Ex :  column wrap-reverse</td>
                    <td>Combine la direction et le wrap</td>
                </tr>
                <tr>
                    <td>justify-content</td>
                    <td><ul>
                    <li>flex-start</li>
                        <li>flex-end</li>
                        <li>center</li>
                        <li>space-between</li>
                        <li>space-around</li>
                    </ul></td>
                    <td>S'applique sur l'axe principale</td>
                </tr>
                <tr>
                    <td>align-items</td>
                    <td>
                    <ul>
                        <li>flex-start</li>
                        <li>flex-end</li>
                        <li>center</li>
                        <li>stretch</li>
                        <li>baseline</li>
                    </ul>
                    </td>
                    <td>S'applique sur l'axe secondaire</td>
                </tr>
                <tr>
                    <td>align-content</td>
                    <td><ul>
                    <li>flex-start</li>
                        <li>flex-end</li>
                        <li>center</li>
                        <li>stretch</li>
                        <li>space-between</li>
                        <li>space-around</li>
                    </ul></td>
                    <td>Alignement de l'interieur du bloc de l'axe secondaire. Prends le dessus sur align-item, visible uniquement si plusieurs lignes ou colonnes. L'alignement ne se fait pas sur l'axe mais en fonction des dimension de la boite.</td>
                </tr>
            </table>
            <h2>Propriétés pour des enfants</h2>
            <table>
            <thead><tr><th>Propriétés</th><th>Valeurs</th><th>Détails</th></tr></thead>
             <tr>
                 <td>order</td>
                 <td>4</td>
                 <td>Modifie l'ordre visuel de chaque élement</td>
             </tr>
             <tr>
                 <td>align-self</td>
                 <td>Comme align-item</td>
                 <td>Surcharge le align-item du parent</td>
             </tr>
             <tr>
                 <td>flex-grow</td>
                 <td>2</td>
                 <td>Facteur d'expansion</td>
             </tr>
             <tr>
                 <td>flex-shrink</td>
                 <td>2</td>
                 <td>Facteur de rétrécissement</td>
             </tr>
             <tr>
                 <td>flex-basis</td>
                 <td>80%</td>
                 <td>Force la valeur d'un enfant</td>
             </tr>
             <tr>
                 <td>flex</td>
                 <td>1 1 100x</td>
                 <td>flex-grow,flex-shrink,flex-basis</td>
             </tr>
            </table>
      </div>
    )
}
